import { apiSlice } from '../../api/apiSlice';
import type { paths } from '../../../../src/generated/api-types';

type LoginRequest =
  paths['/auth/login']['post']['requestBody']['content']['application/json'];
type SignupRequest =
  paths['/auth/signup']['post']['requestBody']['content']['application/json'];
type LoginResponse =
  paths['/auth/login']['post']['responses']['200']['content']['application/json'];
type SignupResponse =
  paths['/auth/signup']['post']['responses']['201']['content']['application/json'];
type MeResponse =
  paths['/auth/me']['get']['responses']['200']['content']['application/json'];

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: credentials => ({
        url: '/auth/login',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['User'],
    }),
    signup: builder.mutation<SignupResponse, SignupRequest>({
      query: userData => ({
        url: '/auth/signup',
        method: 'POST',
        body: userData,
      }),
      invalidatesTags: ['User'],
    }),
    logout: builder.mutation<void, void>({
      query: () => ({
        url: '/auth/logout',
        method: 'POST',
      }),
      invalidatesTags: ['User', 'Collection'],
    }),
    refresh: builder.mutation<MeResponse, void>({
      query: () => ({
        url: '/auth/refresh',
        method: 'POST',
      }),
      invalidatesTags: ['User'],
    }),
    getMe: builder.query<MeResponse, void>({
      query: () => '/auth/me',
      providesTags: ['User'],
    }),
  }),
});

export const {
  useLoginMutation,
  useSignupMutation,
  useLogoutMutation,
  useRefreshMutation,
  useGetMeQuery,
  useLazyGetMeQuery,
} = authApiSlice;
